<template>
  <div class="block">
    <img src="../assets/logo.png" alt="">  
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .block{
    background-color: transparent;
  }
  i{
    font-size: 30px;
  }
  img{
    width: 70px;
    border-radius:40px ;
    margin-top: 10px;
    margin-left: 20px;
  }
</style>